import React, { useEffect, useState } from 'react';
import './i18n';
import { useTranslation } from 'react-i18next';
import { useCart } from './hooks/useCart';
import { useHolidayBackground } from './hooks/useHolidayBackground';
import { loadAllServices } from './services/globalServices';
import MainPage from './components/MainPage/MainPage';
import PricePage from './components/PricePage/PricePage';
import RadiologyPage from './components/RadiologyPage/RadiologyPage';
import CTPage from './components/CTPage/CTPage';
import XRayPage from './components/XRayPage/XRayPage';
import MRIPage from './components/MRIPage/MRIPage';
import LabPage from './components/LabPage/LabPage';
import MicroscopyPage from './components/MicroscopyPage/MicroscopyPage';
import MicroscopyUroPage from './components/MicroscopyUroPage/MicroscopyUroPage';
import ClinicalPage from './components/ClinicalPage/ClinicalPage';
import BloodPage from './components/BloodPage/BloodPage';
import BiochemistryPage from './components/BiochemistryPage/BiochemistryPage';
import CoagulationPage from './components/CoagulationPage/CoagulationPage';
import SerologyPage from './components/SerologyPage/SerologyPage';
import ExpressPage from './components/ExpressPage/ExpressPage';
import CytologyPage from './components/CytologyPage/CytologyPage';
import CheckupPage from './components/CheckupPage/CheckupPage';
import MaleHealthPage from './components/MaleHealthPage/MaleHealthPage';
import FemaleHealthPage from './components/FemaleHealthPage/FemaleHealthPage';
import CardioPreventionPage from './components/CardioPreventionPage/CardioPreventionPage';
import InfectionControlPage from './components/InfectionControlPage/InfectionControlPage';
import FunctionalPage from './components/FunctionalPage/FunctionalPage';
import CosmetologyPage from './components/CosmetologyPage/CosmetologyPage';
import RemovalPage from './components/RemovalPage/RemovalPage';
import PhototherapyPage from './components/PhototherapyPage/PhototherapyPage';
import VesselRemovalPage from './components/VesselRemovalPage/VesselRemovalPage';
import SkinResurfacingPage from './components/SkinResurfacingPage/SkinResurfacingPage';
import DoctorsPage from './components/DoctorsPage/DoctorsPage';
import FaqPage from './components/FaqPage/FaqPage';
import ReviewPage from './components/ReviewPage/ReviewPage';
import DoctorServicesPage from './components/DoctorServicesPage/DoctorServicesPage';
import HealthCheckPage from './components/HealthCheckPage/HealthCheckPage';
import CartPage from './components/CartPage/CartPage';
import EducationalBlock from './components/EducationalBlock/EducationalBlock';
import ProfilePage from './components/ProfilePage/ProfilePage';
import AdminPanel from './components/AdminPanel/AdminPanel';
import StaffPage from './components/StaffPage/StaffPage';
import DoctorPanel from './components/DoctorPanel/DoctorPanel';
import BottomMenu from './components/BottomMenu/BottomMenu';
import './App.css';

function App() {
  const { i18n } = useTranslation();
  const [user, setUser] = useState(null);
  const [currentPage, setCurrentPage] = useState('main');
  const [selectedDoctor, setSelectedDoctor] = useState(null);
  const [showCart, setShowCart] = useState(false);
  const [servicesReady, setServicesReady] = useState(false);
  const [isAuthChecking, setIsAuthChecking] = useState(true);
  
  const [isEducationalFullScreen, setIsEducationalFullScreen] = useState(false);
  
  const [adminIps, setAdminIps] = useState([
    { id: 1, ip: '127.0.0.1' },
    { id: 2, ip: '192.168.1.100' },
    { id: 3, ip: '138.124.24.48'}
  ]);
  
  const {
    cartItems,
    loading: cartLoading,
    setUser: setCartUser,
    addToCart,
    addMultipleToCart,
    removeFromCart,
    updateQuantity,
    clearCart,
    getCartTotal,
    getItemsCount,
  } = useCart();
  
  const { backgroundImage, holidayName } = useHolidayBackground();
  
  const tg = window.Telegram?.WebApp;

  useEffect(() => {
    const initServices = async () => {
      await loadAllServices();
      setServicesReady(true);
    };
    initServices();
  }, []);

  useEffect(() => {
    const checkAuth = () => {
      const token = localStorage.getItem('authToken');
      const savedUser = localStorage.getItem('currentUser');
      
      if (token && savedUser) {
        try {
          const userData = JSON.parse(savedUser);
          setUser(userData);
          setCartUser(userData.id);
        } catch (e) {
          console.error('Ошибка парсинга пользователя:', e);
        }
      }
      setIsAuthChecking(false);
    };
    
    checkAuth();
  }, [setCartUser]);

  useEffect(() => {
    if (user?.id) {
      setCartUser(user.id);
    } else {
      setCartUser(null);
    }
  }, [user, setCartUser]);

  const handleUpdateAdmins = (newIps) => {
    setAdminIps(newIps);
  };

  const handleNavigate = (page) => {
    if (page === 'cart') {
      if (!user) {
        showNotification('Требуется авторизация', 'Пожалуйста, войдите в профиль, чтобы просмотреть корзину');
        setCurrentPage('profile');
        return;
      }
      setShowCart(true);
      setCurrentPage('cart');
    } else if (page === 'main') {
      setCurrentPage('main');
      setShowCart(false);
    } else if (page === 'profile') {
      setCurrentPage('profile');
      setShowCart(false);
    } else if (page === 'admin') {
      setCurrentPage('admin');
      setShowCart(false);
    } else if (page === 'staff') {
      setCurrentPage('staff');
      setShowCart(false);
    } else if (page === 'doctor') {
      setCurrentPage('doctor');
      setShowCart(false);
    }
  };

  const handleOpenStaff = () => {
    setCurrentPage('staff');
  };

  const handleOpenDoctor = () => {
    setCurrentPage('doctor');
  };

  const registeredButtons = [
    'Расписание медосмотров',
    'Программы и стоимость медосмотров',
    'Главная',
    'На главную',
    'Назад',
    'Расписание',
    'Программы/Стоимость',
    'Цены и пакеты услуг',
    'Часы работы и записи',
    'На приём или обследование',
    'Записаться',
    'Запись на медосмотр'
  ];

  const showNotification = (title, message) => {
    if (tg) {
      try {
        if (typeof tg.showPopup === 'function') {
          tg.showPopup({
            title: title,
            message: message,
            buttons: [{ type: 'close' }]
          });
        } else if (typeof tg.showAlert === 'function') {
          tg.showAlert(`${title}: ${message}`);
        } else {
          console.log(`${title}: ${message}`);
        }
      } catch (error) {
        console.error('Telegram notification error:', error);
        alert(`${title}: ${message}`);
      }
    } else {
      alert(`${title}: ${message}`);
    }
  };

  const showCartNotification = (count) => {
    const message = `${count} ${getServicesWord(count)} добавлено в корзину`;
    
    if (tg) {
      try {
        if (typeof tg.showPopup === 'function') {
          tg.showPopup({
            title: '✅ Добавлено в корзину',
            message: message,
            buttons: [{ type: 'close' }]
          });
        } else if (typeof tg.showAlert === 'function') {
          tg.showAlert(`✅ ${message}`);
        } else {
          console.log(`✅ ${message}`);
        }
      } catch (error) {
        console.error('Telegram notification error:', error);
        alert(`✅ ${message}`);
      }
    } else {
      alert(`✅ ${message}`);
    }
  };

  const getServicesWord = (count) => {
    if (count % 10 === 1 && count % 100 !== 11) return 'услуга';
    if ([2, 3, 4].includes(count % 10) && ![12, 13, 14].includes(count % 100)) return 'услуги';
    return 'услуг';
  };

  const setupBackButton = (show) => {
    if (!tg) return;

    try {
      if (tg.BackButton) {
        if (show) {
          if (typeof tg.BackButton.show === 'function') {
            tg.BackButton.show();
          }
          if (typeof tg.BackButton.onClick === 'function') {
            tg.BackButton.offClick(handleBack);
            tg.BackButton.onClick(handleBack);
          }
        } else {
          if (typeof tg.BackButton.hide === 'function') {
            tg.BackButton.hide();
          }
          if (typeof tg.BackButton.offClick === 'function') {
            tg.BackButton.offClick(handleBack);
          }
        }
      }
    } catch (error) {
      console.error('BackButton error:', error);
    }
  };

  useEffect(() => {
    console.log('App инициализируется...');
    
    const savedLang = localStorage.getItem('i18nextLng');
    
    if (savedLang) {
      console.log('Используем сохраненный язык:', savedLang);
      i18n.changeLanguage(savedLang);
    } else if (tg?.initDataUnsafe?.user?.language_code) {
      const telegramLang = tg.initDataUnsafe.user.language_code;
      const langMap = { 'ru': 'ru', 'en': 'en', 'tt': 'tt', 'fr': 'fr', 'pt': 'pt', 'hi': 'hi' };
      const lang = langMap[telegramLang] || 'ru';
      console.log('Используем язык Telegram:', lang);
      i18n.changeLanguage(lang);
      localStorage.setItem('i18nextLng', lang);
    } else {
      console.log('Используем язык по умолчанию: ru');
      i18n.changeLanguage('ru');
    }
  }, [tg, i18n]);

  useEffect(() => {
    if (tg) {
      try {
        tg.expand();
        
        const userData = tg.initDataUnsafe?.user;
        if (userData && !user) {
          setUser(userData);
        }

        setupBackButton(currentPage !== 'main' || isEducationalFullScreen);

      } catch (error) {
        console.error('Telegram initialization error:', error);
      }
    }
  }, [tg, currentPage, isEducationalFullScreen]);

  useEffect(() => {
    setupBackButton(currentPage !== 'main' || isEducationalFullScreen);
  }, [currentPage, isEducationalFullScreen]);

  const isButtonRegistered = (buttonName) => {
    if (!buttonName || buttonName === '') return false;
    
    if (registeredButtons.includes(buttonName)) {
      return true;
    }
    
    const navigationKeywords = [
      'расписание', 'программа', 'стоимость', 'главная', 'назад',
      'цена', 'услуг', 'работы', 'записи', 'записаться'
    ];
    
    const lowerName = buttonName.toLowerCase();
    for (let keyword of navigationKeywords) {
      if (lowerName.includes(keyword)) {
        return true;
      }
    }
    
    return false;
  };

  const handleButtonClick = (buttonName, price = '') => {
    console.log('Клик по кнопке:', buttonName, 'Цена:', price);
    
    if (isButtonRegistered(buttonName)) {
      const message = price ? `${buttonName} - ${price}` : buttonName;
      showNotification('Вы выбрали', message);
      return;
    }
    
    console.log('Незарегистрированная кнопка, открываем календарь для:', buttonName);
  };

  const handleAddToCart = (item) => {
    if (!user) {
      showNotification('Требуется авторизация', 'Пожалуйста, войдите в профиль, чтобы добавить услуги в корзину');
      setCurrentPage('profile');
      return false;
    }
    return addToCart(item);
  };

  const handleAddMultipleToCart = (items) => {
    if (!user) {
      showNotification('Требуется авторизация', 'Пожалуйста, войдите в профиль, чтобы добавить услуги в корзину');
      setCurrentPage('profile');
      return false;
    }
    return addMultipleToCart(items);
  };

  const handleOpenEducational = () => {
    setIsEducationalFullScreen(true);
  };

  const handleCloseEducational = () => {
    setIsEducationalFullScreen(false);
  };

  const handleOpenFaq = () => {
    setCurrentPage('faq');
  };

  const handleOpenReview = () => {
    setCurrentPage('review');
  };

  const handleOpenDoctorServices = (doctor) => {
    setSelectedDoctor(doctor);
    setCurrentPage('doctorServices');
  };

  const handleBackFromServices = () => {
    setCurrentPage('doctors');
  };

  const handleOpenPrice = () => {
    setCurrentPage('price');
  };

  const handleOpenRadiology = () => {
    setCurrentPage('radiology');
  };

  const handleOpenCT = () => {
    setCurrentPage('ct');
  };

  const handleOpenXRay = () => {
    setCurrentPage('xray');
  };

  const handleOpenMRI = () => {
    setCurrentPage('mri');
  };

  const handleOpenLab = () => {
    setCurrentPage('lab');
  };

  const handleOpenMicroscopy = () => {
    setCurrentPage('microscopy');
  };

  const handleOpenMicroscopyUro = () => {
    setCurrentPage('microscopyUro');
  };

  const handleOpenClinical = () => {
    setCurrentPage('clinical');
  };

  const handleOpenBlood = () => {
    setCurrentPage('blood');
  };

  const handleOpenBiochemistry = () => {
    setCurrentPage('biochemistry');
  };

  const handleOpenCoagulation = () => {
    setCurrentPage('coagulation');
  };

  const handleOpenSerology = () => {
    setCurrentPage('serology');
  };

  const handleOpenExpress = () => {
    setCurrentPage('express');
  };

  const handleOpenCytology = () => {
    setCurrentPage('cytology');
  };

  const handleOpenCheckup = () => {
    setCurrentPage('checkup');
  };

  const handleOpenMaleHealth = () => {
    setCurrentPage('maleHealth');
  };

  const handleOpenFemaleHealth = () => {
    setCurrentPage('femaleHealth');
  };

  const handleOpenCardioPrevention = () => {
    setCurrentPage('cardioPrevention');
  };

  const handleOpenInfectionControl = () => {
    setCurrentPage('infectionControl');
  };

  const handleOpenFunctional = () => {
    setCurrentPage('functional');
  };

  const handleOpenCosmetology = () => {
    setCurrentPage('cosmetology');
  };

  const handleOpenRemoval = () => {
    setCurrentPage('removal');
  };

  const handleOpenPhototherapy = () => {
    setCurrentPage('phototherapy');
  };

  const handleOpenVesselRemoval = () => {
    setCurrentPage('vesselRemoval');
  };

  const handleOpenSkinResurfacing = () => {
    setCurrentPage('skinResurfacing');
  };

  const handleOpenDoctors = () => {
    setCurrentPage('doctors');
  };

  const handleOpenHealthCheck = () => {
    setCurrentPage('healthCheck');
  };


  const handleOpenCart = () => {
    if (!user) {
      showNotification('Требуется авторизация', 'Пожалуйста, войдите в профиль, чтобы просмотреть корзину');
      setCurrentPage('profile');
      return;
    }
    setShowCart(true);
    setCurrentPage('cart');
  };

  const handleCloseCart = () => {
    setShowCart(false);
    setCurrentPage('main');
  };

  const handleBack = () => {
    if (isEducationalFullScreen) {
      handleCloseEducational();
      return;
    }
    
    if (currentPage === 'cart') {
      setCurrentPage('main');
      setShowCart(false);
    } else if (currentPage === 'ct' || currentPage === 'xray' || currentPage === 'mri') {
      setCurrentPage('radiology');
    } else if (currentPage === 'microscopy' || currentPage === 'microscopyUro' || currentPage === 'clinical' || currentPage === 'blood' || currentPage === 'biochemistry' || currentPage === 'coagulation' || currentPage === 'serology' || currentPage === 'express' || currentPage === 'cytology') {
      setCurrentPage('lab');
    } else if (currentPage === 'maleHealth' || currentPage === 'femaleHealth' || currentPage === 'cardioPrevention' || currentPage === 'infectionControl') {
      setCurrentPage('checkup');
    } else if (currentPage === 'removal' || currentPage === 'phototherapy' || currentPage === 'vesselRemoval' || currentPage === 'skinResurfacing') {
      setCurrentPage('cosmetology');
    } else if (currentPage === 'functional' || currentPage === 'cosmetology' || currentPage === 'doctors') {
      setCurrentPage('price');
    } else if (currentPage === 'checkup') {
      setCurrentPage('price');
    } else if (currentPage === 'radiology' || currentPage === 'lab') {
      setCurrentPage('price');
    } else if (currentPage === 'price') {
      setCurrentPage('main');
    } else if (currentPage === 'faq') {
      setCurrentPage('main');
    } else if (currentPage === 'review') {
      setCurrentPage('main');
    } else if (currentPage === 'doctorServices') {
      setCurrentPage('doctors');
    } else if (currentPage === 'healthCheck') {
      setCurrentPage('main');
    } else if (currentPage === 'profile') {
      setCurrentPage('main');
    } else if (currentPage === 'admin') {
      setCurrentPage('main');
    } else if (currentPage === 'staff') {
      setCurrentPage('main');
    } else if (currentPage === 'doctor') {
      setCurrentPage('main');
    }

    setupBackButton(currentPage !== 'main');
  };

  const handleBackToRadiology = () => {
    setCurrentPage('radiology');
  };

  const handleBackToPrice = () => {
    setCurrentPage('price');
  };

  const handleBackToLab = () => {
    setCurrentPage('lab');
  };

  const handleBackToCheckup = () => {
    setCurrentPage('checkup');
  };

  const handleBackToCosmetology = () => {
    setCurrentPage('cosmetology');
  };

  const appStyle = backgroundImage ? {
    '--holiday-bg': `url(${backgroundImage})`
  } : {};

  const showBottomMenu = !isEducationalFullScreen && 
    currentPage !== 'faq' && 
    currentPage !== 'review' &&
    currentPage !== 'doctorServices';

  if (!servicesReady || isAuthChecking) {
    return (
      <div className="App">
        <div className="container">
          <div className="loading-screen">
            <div className="loading-spinner"></div>
            <p>{!servicesReady ? 'Загрузка услуг...' : 'Проверка авторизации...'}</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div 
      className={`App ${backgroundImage ? 'holiday-background' : ''}`} 
      style={appStyle}
    >
      <div className="container">
        {isEducationalFullScreen ? (
          <EducationalBlock 
            isFullScreenMode={true}
            onClose={handleCloseEducational}
          />
        ) : (
          <>
            {currentPage === 'main' && (
              <MainPage 
                onButtonClick={handleButtonClick}
                onOpenPrice={handleOpenPrice}
                onOpenFaq={handleOpenFaq}
                onOpenReview={handleOpenReview}
                user={user}
                onOpenRadiology={handleOpenRadiology}
                onOpenLab={handleOpenLab}
                onOpenCheckup={handleOpenCheckup}
                onOpenFunctional={handleOpenFunctional}
                onOpenCosmetology={handleOpenCosmetology}
                onOpenDoctors={handleOpenDoctors}
                onOpenCT={handleOpenCT}
                onOpenXRay={handleOpenXRay}
                onOpenMRI={handleOpenMRI}
                onOpenMaleHealth={handleOpenMaleHealth}
                onOpenFemaleHealth={handleOpenFemaleHealth}
                onOpenCardioPrevention={handleOpenCardioPrevention}
                onOpenInfectionControl={handleOpenInfectionControl}
                onOpenRemoval={handleOpenRemoval}
                onOpenPhototherapy={handleOpenPhototherapy}
                onOpenVesselRemoval={handleOpenVesselRemoval}
                onOpenSkinResurfacing={handleOpenSkinResurfacing}
                onOpenDoctorServices={handleOpenDoctorServices}
                onOpenHealthCheck={handleOpenHealthCheck}
                onOpenEducational={handleOpenEducational}
              />
            )}
            
            {currentPage === 'price' && (
              <PricePage 
                onButtonClick={handleButtonClick}
                onBack={handleBack}
                onOpenRadiology={handleOpenRadiology}
                onOpenLab={handleOpenLab}
                onOpenCheckup={handleOpenCheckup}
                onOpenFunctional={handleOpenFunctional}
                onOpenCosmetology={handleOpenCosmetology}
                onOpenDoctors={handleOpenDoctors}
              />
            )}
            
            {currentPage === 'radiology' && (
              <RadiologyPage 
                onButtonClick={handleButtonClick}
                onBack={handleBack}
                onOpenCT={handleOpenCT}
                onOpenXRay={handleOpenXRay}
                onOpenMRI={handleOpenMRI}
              />
            )}

            {currentPage === 'faq' && (
              <FaqPage 
                onButtonClick={handleButtonClick}
                onBack={handleBack}
              />
            )}

            {currentPage === 'review' && (
              <ReviewPage 
                onButtonClick={handleButtonClick}
                onBack={handleBack}
                user={user}
              />
            )}

            {currentPage === 'doctorServices' && selectedDoctor && (
              <DoctorServicesPage 
                onBack={handleBackFromServices}
                doctor={selectedDoctor}
                onAddToCart={handleAddToCart}
                onAddMultipleToCart={handleAddMultipleToCart}
                onShowCartNotification={showCartNotification}
              />
            )}

            {currentPage === 'ct' && (
              <CTPage 
                onBack={handleBackToRadiology}
                onAddToCart={handleAddToCart}
                onAddMultipleToCart={handleAddMultipleToCart}
                onShowCartNotification={showCartNotification}
              />
            )}

            {currentPage === 'xray' && (
              <XRayPage 
                onBack={handleBackToRadiology}
                onAddToCart={handleAddToCart}
                onAddMultipleToCart={handleAddMultipleToCart}
                onShowCartNotification={showCartNotification}
              />
            )}

            {currentPage === 'mri' && (
              <MRIPage 
                onBack={handleBackToRadiology}
                onAddToCart={handleAddToCart}
                onAddMultipleToCart={handleAddMultipleToCart}
                onShowCartNotification={showCartNotification}
              />
            )}

            {currentPage === 'lab' && (
              <LabPage 
                onButtonClick={handleButtonClick}
                onBack={handleBackToPrice}
                onOpenMicroscopy={handleOpenMicroscopy}
                onOpenMicroscopyUro={handleOpenMicroscopyUro}
                onOpenClinical={handleOpenClinical}
                onOpenBlood={handleOpenBlood}
                onOpenBiochemistry={handleOpenBiochemistry}
                onOpenCoagulation={handleOpenCoagulation}
                onOpenSerology={handleOpenSerology}
                onOpenExpress={handleOpenExpress}
                onOpenCytology={handleOpenCytology}
              />
            )}

            {currentPage === 'microscopy' && (
              <MicroscopyPage 
                onBack={handleBackToLab}
                onAddToCart={handleAddToCart}
                onAddMultipleToCart={handleAddMultipleToCart}
                onShowCartNotification={showCartNotification}
              />
            )}

            {currentPage === 'microscopyUro' && (
              <MicroscopyUroPage 
                onBack={handleBackToLab}
                onAddToCart={handleAddToCart}
                onAddMultipleToCart={handleAddMultipleToCart}
                onShowCartNotification={showCartNotification}
              />
            )}

            {currentPage === 'clinical' && (
              <ClinicalPage 
                onBack={handleBackToLab}
                onAddToCart={handleAddToCart}
                onAddMultipleToCart={handleAddMultipleToCart}
                onShowCartNotification={showCartNotification}
              />
            )}

            {currentPage === 'blood' && (
              <BloodPage 
                onBack={handleBackToLab}
                onAddToCart={handleAddToCart}
                onAddMultipleToCart={handleAddMultipleToCart}
                onShowCartNotification={showCartNotification}
              />
            )}

            {currentPage === 'biochemistry' && (
              <BiochemistryPage 
                onBack={handleBackToLab}
                onAddToCart={handleAddToCart}
                onAddMultipleToCart={handleAddMultipleToCart}
                onShowCartNotification={showCartNotification}
              />
            )}

            {currentPage === 'coagulation' && (
              <CoagulationPage 
                onBack={handleBackToLab}
                onAddToCart={handleAddToCart}
                onAddMultipleToCart={handleAddMultipleToCart}
                onShowCartNotification={showCartNotification}
              />
            )}

            {currentPage === 'serology' && (
              <SerologyPage 
                onBack={handleBackToLab}
                onAddToCart={handleAddToCart}
                onAddMultipleToCart={handleAddMultipleToCart}
                onShowCartNotification={showCartNotification}
              />
            )}

            {currentPage === 'express' && (
              <ExpressPage 
                onBack={handleBackToLab}
                onAddToCart={handleAddToCart}
                onAddMultipleToCart={handleAddMultipleToCart}
                onShowCartNotification={showCartNotification}
              />
            )}

            {currentPage === 'cytology' && (
              <CytologyPage 
                onBack={handleBackToLab}
                onAddToCart={handleAddToCart}
                onAddMultipleToCart={handleAddMultipleToCart}
                onShowCartNotification={showCartNotification}
              />
            )}

            {currentPage === 'checkup' && (
              <CheckupPage 
                onButtonClick={handleButtonClick}
                onBack={handleBackToPrice}
                onOpenMaleHealth={handleOpenMaleHealth}
                onOpenFemaleHealth={handleOpenFemaleHealth}
                onOpenCardioPrevention={handleOpenCardioPrevention}
                onOpenInfectionControl={handleOpenInfectionControl}
              />
            )}

            {currentPage === 'maleHealth' && (
              <MaleHealthPage 
                onBack={handleBackToCheckup}
                onAddToCart={handleAddToCart}
                onAddMultipleToCart={handleAddMultipleToCart}
                onShowCartNotification={showCartNotification}
              />
            )}

            {currentPage === 'femaleHealth' && (
              <FemaleHealthPage 
                onBack={handleBackToCheckup}
                onAddToCart={handleAddToCart}
                onAddMultipleToCart={handleAddMultipleToCart}
                onShowCartNotification={showCartNotification}
              />
            )}

            {currentPage === 'cardioPrevention' && (
              <CardioPreventionPage 
                onBack={handleBackToCheckup}
                onAddToCart={handleAddToCart}
                onAddMultipleToCart={handleAddMultipleToCart}
                onShowCartNotification={showCartNotification}
              />
            )}

            {currentPage === 'infectionControl' && (
              <InfectionControlPage 
                onBack={handleBackToCheckup}
                onAddToCart={handleAddToCart}
                onAddMultipleToCart={handleAddMultipleToCart}
                onShowCartNotification={showCartNotification}
              />
            )}

            {currentPage === 'functional' && (
              <FunctionalPage 
                onBack={handleBackToPrice}
                onAddToCart={handleAddToCart}
                onAddMultipleToCart={handleAddMultipleToCart}
                onShowCartNotification={showCartNotification}
              />
            )}

            {currentPage === 'cosmetology' && (
              <CosmetologyPage 
                onButtonClick={handleButtonClick}
                onBack={handleBackToPrice}
                onOpenRemoval={handleOpenRemoval}
                onOpenPhototherapy={handleOpenPhototherapy}
                onOpenVesselRemoval={handleOpenVesselRemoval}
                onOpenSkinResurfacing={handleOpenSkinResurfacing}
              />
            )}

            {currentPage === 'removal' && (
              <RemovalPage 
                onBack={handleBackToCosmetology}
                onAddToCart={handleAddToCart}
                onAddMultipleToCart={handleAddMultipleToCart}
                onShowCartNotification={showCartNotification}
              />
            )}

            {currentPage === 'phototherapy' && (
              <PhototherapyPage 
                onBack={handleBackToCosmetology}
                onAddToCart={handleAddToCart}
                onAddMultipleToCart={handleAddMultipleToCart}
                onShowCartNotification={showCartNotification}
              />
            )}

            {currentPage === 'vesselRemoval' && (
              <VesselRemovalPage 
                onBack={handleBackToCosmetology}
                onAddToCart={handleAddToCart}
                onAddMultipleToCart={handleAddMultipleToCart}
                onShowCartNotification={showCartNotification}
              />
            )}

            {currentPage === 'skinResurfacing' && (
              <SkinResurfacingPage 
                onBack={handleBackToCosmetology}
                onAddToCart={handleAddToCart}
                onAddMultipleToCart={handleAddMultipleToCart}
                onShowCartNotification={showCartNotification}
              />
            )}

            {currentPage === 'doctors' && (
              <DoctorsPage 
                onButtonClick={handleButtonClick}
                onBack={handleBack}
                onOpenDoctorServices={handleOpenDoctorServices}
              />
            )}

            {currentPage === 'healthCheck' && (
              <HealthCheckPage 
                onButtonClick={handleButtonClick}
                onBack={handleBack}
                onAddToCart={handleAddToCart}
                onAddMultipleToCart={handleAddMultipleToCart}
                onShowCartNotification={showCartNotification}
              />
            )}

            {currentPage === 'cart' && (
              <CartPage 
                cartItems={cartItems}
                onRemoveFromCart={removeFromCart}
                onUpdateQuantity={updateQuantity}
                onClearCart={clearCart}
                onBack={handleCloseCart}
                totalAmount={getCartTotal()}
                loading={cartLoading}
              />
            )}

            {currentPage === 'profile' && (
              <ProfilePage 
                user={user}
                onBack={handleBack}
                onLogout={() => {
                  setUser(null);
                  setCartUser(null);
                  setCurrentPage('main');
                }}
                onLogin={(userData) => {
                  setUser(userData);
                  setCartUser(userData.id);
                }}
                  onOpenStaff={() => setCurrentPage('staff')}
  onOpenDoctor={() => setCurrentPage('doctor')}
              />
            )}

            {currentPage === 'admin' && (
              <AdminPanel 
                onBack={handleBack}
                cartItems={cartItems}
                user={user}
                onUpdateAdmins={handleUpdateAdmins}
                adminIps={adminIps}
              />
            )}

            {currentPage === 'staff' && (
              <StaffPage 
                onBack={() => setCurrentPage('main')}
                user={user}
              />
            )}

            {currentPage === 'doctor' && (
              <DoctorPanel 
                onBack={() => setCurrentPage('main')}
                user={user}
              />
            )}
          </>
        )}

        {showBottomMenu && (
          <BottomMenu
            currentPage={currentPage}
            onNavigate={handleNavigate}
            cartItemsCount={getItemsCount()}
            adminIps={adminIps}
            onOpenEducational={handleOpenEducational}
            onOpenStaff={handleOpenStaff}
            onOpenDoctor={handleOpenDoctor}
          />
        )}
      </div>
    </div>
  );
}

export default App;